<template>
  <div v-if="page.service" class="page page-dark page-service">
    <div class="container">
      <div v-html="page.service.text_lead_dark" class="lead lead-intro col-md-12"/>

      <div class="col-md-8 col-service col-service-first">
        <h1>{{ page.service.name }}</h1>
      </div>

      <div class="col-md-12 col-service col-service-space">
        <div v-html="page.service.text_main_title_dark" class="font-grotesque"/>
        <div class="col-service-text" v-html="page.service.text_main_dark"/>
      </div>

      <div class="col-md-12 col-service col-service-hulk">
        <div class="font-grotesque" v-html="page.service.text_law_title_dark"/>
        <div class="col-service-text" v-html="page.service.text_law_dark"/>
      </div>

      <div class="col-md-12 col-service col-service-parachute">
        <div class="font-grotesque" v-html="page.service.text_corporate_title_dark"/>
        <div class="col-service-text" v-html="page.service.text_corporate_dark"/>
      </div>

      <div class="col-md-12 col-service col-service-cubes">
        <div class="font-grotesque" v-html="page.service.text_actives_title_dark"/>
        <div class="col-service-text" v-html="page.service.text_actives_dark"/>
      </div>
  </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'serviceDark',
  computed: mapGetters({
    page: 'page',
  }),
};
</script>

<style>
.page{
  &-service{
    position: relative;
    z-index: 11;

    .lead{
      margin-left: 30%;
      @media (min-width: $mediaMob) {
        max-width: 70%;
        width: 550px;
      }
    }
    .service-money{
      position: absolute;
      top: 0;
      right: 0%;
      width: 40%;
      
      img{
        height: auto;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ServiceDark.vue